import React, { useState, useCallback, useContext } from 'react';
import {
  Button,
  IconButton,
  Dialog,
  DialogActions,
  DialogContent,
  Theme,
  useMediaQuery,
  Typography,
  Grid,
} from '@material-ui/core';
import { useTheme } from '@material-ui/styles';

import { TimesIcon } from '../../../../components/icon/solid';
import { UploadPanelStyles } from './styles';
import { UploadContext } from '../useUploadFiles';

type Props = {
  closeUploadPanel: () => void;
};

const CloseAction = ({ closeUploadPanel }: Props) => {
  const { files, downloadFiles, removeAllFiles, cancelAllFiles } = useContext(UploadContext);
  const classes = UploadPanelStyles();
  const theme = useTheme<Theme>();
  const fullScreen = useMediaQuery(theme.breakpoints.down('xs'));
  const [open, setOpen] = useState(false);

  const openHandler = useCallback(() => {
    setOpen((open) => !open);
  }, [setOpen]);

  const closeUploadPanelHandler = useCallback(() => {
    const uploadingFiles = files.filter((item) => item.meta.status === 'uploading' || item.meta.status === 'ready').length;
    const downloadingFiles = downloadFiles.filter((item) => item.status === 'downloading' || item.status === 'requested').length;
    const processingFiles = uploadingFiles + downloadingFiles;
    if (processingFiles > 0) {
      openHandler();
    } else {
      removeAllFiles();
      closeUploadPanel();
    }
  }, [closeUploadPanel, openHandler, files, downloadFiles, removeAllFiles]);

  const cancelUploads = useCallback(() => {
    cancelAllFiles();
    closeUploadPanel();
    openHandler();
  }, [closeUploadPanel, openHandler, cancelAllFiles]);

  return (
    <>
      <IconButton onClick={closeUploadPanelHandler} className={classes.headerAction}>
        <TimesIcon className={classes.icon} style={{ fontSize: 18 }} />
      </IconButton>
      <Dialog
        fullScreen={fullScreen}
        disableBackdropClick
        open={open}
        style={{ zIndex: 2147483100 }}
      >
        <DialogContent>
          <Grid container alignItems="center" justify="center" spacing={2}>
            <Grid item style={{ maxWidth: 400 }}>
              <Typography gutterBottom variant="h4" align="center" className={classes.modalTitle} style={{ maxWidth: 400 }}>
                Are you sure you want to cancel all transfers?
              </Typography>
            </Grid>
            <Grid item style={{ maxWidth: 400 }}>
              <Typography gutterBottom variant="body1" align="center" className={classes.modalText} style={{ maxWidth: 400 }}>
                Your transfers are not complete.
              </Typography>
              <Typography gutterBottom variant="body1" align="center" className={classes.modalText} style={{ maxWidth: 400 }}>
                Would you like to cancel all ongoing transfers?
              </Typography>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Grid container alignItems="center" justify="space-between" style={{ maxWidth: 400, margin: 'auto' }} spacing={1}>
            <Grid item style={{ width: 170 }}>
              <Button onClick={openHandler} className={classes.continueAction} variant="outlined">
                Continue Transfers
              </Button>
            </Grid>
            <Grid item style={{ width: 170 }}>
              <Button onClick={cancelUploads} className={classes.cancelAction} variant="outlined">
                Cancel Transfers
              </Button>
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default CloseAction;
